import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Button } from "@mui/material";
import AppPageShell from "./AppPageShell";

const prodURL = "https://club-lab.ru";
const url =
  window.location.hostname === "localhost" ? "http://localhost:3004" : prodURL;

export default function Instruction() {
  const [page, setPage] = useState(1);
  const [pageData, setPageData] = useState(null);
  const instructions = useSelector((state) => state.serviceData?.instructions);

  useEffect(() => {
    if (instructions) {
      const getPage = instructions.find((el) => el.step === page);
      if (getPage) {
        setPageData(getPage);
      }
    }
  }, [instructions, page]);

  return (
    <AppPageShell title="Обучение" subtitle="Пошаговое руководство по работе с сервисом">
      {pageData ? (
        <div className="app-content-card">
          <div className="app-instruction-step">
            <h3 style={{ margin: "0 0 8px", color: "var(--app-heading)" }}>
              Шаг {pageData.step}
            </h3>
            <p style={{ margin: 0, color: "var(--app-muted)" }}>
              {pageData.description}
            </p>
          </div>

          <div className="app-instruction-gallery">
            {pageData.content?.map((el, index) => (
              <div key={index} className="app-instruction-item">
                <img
                  src={`${url}/${el.imgPath}?timestamp=${new Date().getTime()}`}
                  alt="Screenshot"
                  style={{
                    maxWidth: pageData.content.length > 2 ? "350px" : "850px",
                    width: "100%",
                    maxHeight: "500px",
                    objectFit: "contain",
                  }}
                />
                <span className="app-instruction-caption">{el.text}</span>
              </div>
            ))}
          </div>

          <div className="app-instruction-nav">
            {page > 1 ? (
              <Button
                variant="outlined"
                className="app-btn app-btn--secondary"
                onClick={() => setPage(page - 1)}
              >
                Назад
              </Button>
            ) : null}
            <Button
              variant="contained"
              className="app-btn app-btn--primary"
              onClick={() => {
                if (page < instructions.length) {
                  setPage(page + 1);
                }
              }}
            >
              Дальше
            </Button>
          </div>
        </div>
      ) : null}
    </AppPageShell>
  );
}
